import { PublicProfilePage } from './PublicProfilePage'
import { ResignedEmployeeProfilePage } from './resignedEmployeePublicProfile/ResignedEmployeeProfilePage'
import { CurrencyFromContractProvider } from '../../context/currency-context'
import { FC } from 'react'
import { RouteComponentProps } from 'react-router'

interface MatchParams {
  id: string
  resigned?: string
}

export const PublicProfilePageContainer: FC<RouteComponentProps<MatchParams>> = ({ match }): JSX.Element => {
  const employeeId = match.params.id
  const resigned = match.params.resigned ? true : false

  return (
    <CurrencyFromContractProvider employeeId={employeeId}>
      {resigned ? <ResignedEmployeeProfilePage employeeId={employeeId} /> : <PublicProfilePage employeeId={employeeId} />}
    </CurrencyFromContractProvider>
  )
}
